import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ContactFormState {
  name:    string;
  email:   string;
  phone:   string;
  subject: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactFormStateService {
  // Initial leerer State
  private state$ = new BehaviorSubject<ContactFormState>({
    name: '', email: '', phone: '', subject: '', message: ''
  });

  // Observable zum Abonnieren
  readonly values$ = this.state$.asObservable();

  // Methode, um State zu aktualisieren
  update(values: ContactFormState) {
    this.state$.next(values);
  }

  // Optional: Reset
  reset() {
    this.state$.next({ name: '', email: '', phone: '', subject: '', message: '' });
  }
}
